import {
  IExternalStorage,
  KameleoonStorageKey,
  LegalConsent,
} from '@kameleoon/javascript-sdk-core/browser';
import { KameleoonVisitorCodeManager } from './visitorCodeManager';
import { EngineConsentDataType } from './types';

// --- Note ---
// Named `DataStorage` to avoid collision with `Storage` from `window` API
export class DataStorage<T> implements IExternalStorage<T> {
  private visitorCodeManager?: KameleoonVisitorCodeManager;

  public read(key: string): T | null {
    const data = localStorage.getItem(key);

    if (key === KameleoonStorageKey.ConsentData) {
      if (!data || data === '{}') {
        return this.getEngineConsentData();
      }
    }

    return data ? JSON.parse(data) : null;
  }

  public write(key: string, data: T): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  private getEngineConsentData(): T | null {
    if (!this.visitorCodeManager) {
      this.visitorCodeManager = new KameleoonVisitorCodeManager();
    }

    const visitorCode = this.visitorCodeManager.getData(
      KameleoonStorageKey.VisitorCode,
    );

    if (!visitorCode) {
      return null;
    }

    try {
      const engineConsentData = localStorage.getItem('kameleoonLegalConsent');

      if (!engineConsentData) {
        return null;
      }

      const engineConsent: EngineConsentDataType =
        JSON.parse(engineConsentData);

      const abTesting = engineConsent?.value?.AB_TESTING;
      if (typeof abTesting === 'boolean') {
        return {
          [visitorCode]: {
            consent: abTesting ? LegalConsent.Given : LegalConsent.NotGiven,
          },
        } as T;
      }

      return null;
    } catch (_) {
      return null;
    }
  }
}
